import{createContext as t}from"react";const a=t({cartId:null,cartInput:null,hasCartContext:!1,disableOptimisticUpdates:!1});export{a as CartContext};
//# sourceMappingURL=context.js.map
